import { Check } from "lucide-react";

// Ștampilă "PROMOVAT" stil tuș. ink="white" pe fotografii, ink="blue" pe foi albe.
export const Stamp = ({ className = "", ink = "white" }) => {
  const blue = ink === "blue";
  return (
    <div className={`pointer-events-none select-none -rotate-[10deg] ${className}`} data-testid="promovat-stamp">
      <div
        className={`relative rounded-md border-2 px-3 py-1.5 ${blue ? "border-[#1565C0]/75 text-[#1565C0] bg-white/60" : "border-white/85 text-white"}`}
        style={{
          boxShadow: blue
            ? "inset 0 0 0 3px rgba(21,101,192,0.18), 0 2px 10px rgba(15,23,42,0.08)"
            : "inset 0 0 0 3px rgba(255,255,255,0.3), 0 2px 12px rgba(0,0,0,0.25)",
        }}
      >
        <div className="flex items-center gap-1.5">
          <Check size={14} strokeWidth={3.5} />
          <span className="font-display font-extrabold tracking-[0.18em] text-sm leading-none">PROMOVAT</span>
        </div>
        <div className="mt-1 text-center text-[8px] tracking-[0.35em] opacity-85">CATEGORIA B</div>
      </div>
    </div>
  );
};

export default Stamp;
